import { useEffect, useState } from 'react'
import { Tabs } from '@arco-design/web-react'
import type { OptionsAPI } from './useOptions'
import GroupRatioJsonSection from './ratio/GroupRatioJsonSection'
import ModelRatioJsonSection from './ratio/ModelRatioJsonSection'
import UnsetModelsPricingEditor from './ratio/UnsetModelsPricingEditor'
import UpstreamRatioSyncSection from './ratio/UpstreamRatioSyncSection'
import VisualModelPricingEditor from './ratio/VisualModelPricingEditor'
import ChannelCostSetting from './ratio/ChannelCostSetting'

const RATIO_TABS = [
  { key: 'visual', title: '价格设置（售价）', Comp: VisualModelPricingEditor },
  { key: 'cost', title: '进价 / 成本', Comp: ChannelCostSetting },
  { key: 'group', title: '分组相关设置', Comp: GroupRatioJsonSection },
  { key: 'unset_models', title: '未设置价格模型', Comp: UnsetModelsPricingEditor },
  { key: 'upstream_sync', title: '上游倍率同步', Comp: UpstreamRatioSyncSection },
  { key: 'model', title: '高级 · 原始 JSON', Comp: ModelRatioJsonSection },
] as const

type RatioTabKey = (typeof RATIO_TABS)[number]['key']

export default function RatioSetting({ options }: { options: OptionsAPI }) {
  const [activeTab, setActiveTab] = useState<RatioTabKey>('visual')

  // 所有 tab 都保持挂载：只隐藏不销毁，切 tab 不再丢正在编辑的内容
  const [visited, setVisited] = useState<Record<string, boolean>>({ visual: true })
  useEffect(() => {
    setVisited((prev) => (prev[activeTab] ? prev : { ...prev, [activeTab]: true }))
  }, [activeTab])

  const handleTabChange = (next: RatioTabKey) => {
    setActiveTab(next)
  }

  return (
    <div className="ratio-setting-page">
      <div className="settings-risk-alert settings-info-strip">
        「价格设置」是卖给客户的售价，「进价 /
        成本」是我们付给上游的采购价，两者之差即毛利。固定价优先于按量倍率；auto
        分组顺序影响渠道选择；错误 JSON 或负数会在保存前拦截。
      </div>

      <div className="ratio-setting-subtabs">
        <Tabs
          activeTab={activeTab}
          onChange={(k) => handleTabChange(k as RatioTabKey)}
          destroyOnHide={false}
        >
          {RATIO_TABS.map(({ key, title }) => (
            <Tabs.TabPane key={key} title={title} />
          ))}
        </Tabs>
      </div>

      <div className="ratio-setting-content">
        {RATIO_TABS.map(({ key, Comp }) =>
          visited[key] ? (
            <div key={key} style={{ display: key === activeTab ? undefined : 'none' }}>
              <Comp options={options} />
            </div>
          ) : null
        )}
      </div>
    </div>
  )
}
